import styled, { css } from 'styled-components';
import type { Maybe } from 'yup';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { hexToRgba } from '@/theme';

import { visibilityControl } from '../../Card.styles';

export const Wrapper = styled(Box)<{
  $visibleInDesktop?: Maybe<boolean>;
  $visibleInMobile?: Maybe<boolean>;
}>`
  display: block;
  position: relative;
  ${({ $visibleInDesktop, $visibleInMobile }) => css`
    ${visibilityControl($visibleInDesktop, $visibleInMobile)}
  `};
`;

export const Content = styled(Flex)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: background-color 0.25s ease-in-out;
  ${({ theme }) => css`
    z-index: ${theme.zIndex.baseCmsCard};
    background-color: rgba(${hexToRgba(theme.colors.primaryBlue, '0.5')});
    &:hover {
      background-color: rgba(${hexToRgba(theme.colors.primaryBlue, '0.85')});
    }
  `}
`;

export const Heading = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  min-height: 170px;

  ${({ theme }) => css`
    ${theme.media.md.up} {
      min-height: 125px;
      margin-bottom: -${theme.spacing(2)};
    }
  `}
`;
